import { render, staticRenderFns } from "./editSection.vue?vue&type=template&id=3831bde4&scoped=true&"
import script from "./editSection.vue?vue&type=script&lang=js&"
export * from "./editSection.vue?vue&type=script&lang=js&"
import style0 from "./editSection.vue?vue&type=style&index=0&id=3831bde4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831bde4",
  null
  
)

export default component.exports